import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Rimuove eventuali service worker residui da build precedenti
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => reg.unregister());
  });
}

// ── Pulizia emergenza carrello ──────────────────────────────────────────────
// I vecchi salvataggi contenevano image_url base64 (200-500KB per prodotto)
// e riempivano il localStorage. Questo blocco migra / svuota i dati in eccesso
// UNA SOLA VOLTA all'avvio, prima che CartProvider li legga.
(function purgeLargeCart() {
  try {
    const raw = localStorage.getItem('bvesuvio_cart');
    if (!raw) return;
    // Se supera 50 KB è sicuramente il vecchio formato con image_url → rimuovi subito
    if (raw.length > 50 * 1024) {
      localStorage.removeItem('bvesuvio_cart');
      console.info('[Cart] Dati carrello obsoleti rimossi (contenevano base64).');
    }
  } catch { /* localStorage non disponibile */ }
})();
// ────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
